import type { Dictionary } from '../../../shared/lib/functional/dictionary.no-deps'
import * as LaunchDarkly from '../Util/Util.launchdarkly'

const anyWindow = window as any

/**
 * Adds values to the global window object
 */
export function Util_exposeGlobally(toBeExposed: Dictionary<any>) {
    for (const k in toBeExposed) {
        anyWindow[k] = toBeExposed[k]
    }
}

export async function attachFeatureFlagsToWindow() {
    window.getFeatureFlagValue = LaunchDarkly.getFlagValue
}
